import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {MealsRoutingModule} from './meals-routing.module';
import {AngularDateTimePickerModule} from 'angular2-datetimepicker';

const MODULES = [
    SharedModule,
    MealsRoutingModule,
    AngularDateTimePickerModule
];

import {MealsComponent} from './components/meals/meals.component';
import {AddRecipeModalComponent} from './components/modals/add-recipe/add-recipe.component';
import {ViewRecipeComponent} from './components/modals/view-recipe/view-recipe.component';
import {ShoppingListComponent} from './components/modals/shopping-list/shopping-list.component';
import {ExternalMealsComponent} from './components/modals/external-meals/external-meals.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {WeightQtyComponent} from './components/modals/external-meals/weight-qty.component';
import {NouisliderModule} from 'ng2-nouislider';
import {FriendsComponent} from './components/modals/shopping-list/friends.component';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {AddRecipeFilterModalComponent} from './components/modals/add-recipe-filter/add-recipe-filter.component';
import {SendToFriendComponent} from './components/modals/shopping-list/send-to-friend.component';
import {CopyRecipeComponent} from './components/modals/copy-recipe/copy-recipe.component';
import {DiaryTrainingComponent} from './components/modals/diary-training/diary-training.component';
import {DailyChangesActivitiesComponent} from './components/modals/daily-changes-activities/daily-changes-activities.component';
import {ChangeDiaryRecipeProductComponent} from './components/modals/change-diary-recipe-product/change-diary-recipe-product.component';
import {CopyDiaryRecipesComponent} from './components/modals/copy-diary-recipes/copy-diary-recipes.component';
import {DiaryMealComponent} from './components/modals/external-meals/diary-meal/diary-meal.component';
import {DeleteDiaryRecipesComponent} from './components/modals/delete-diary-recipes/delete-diary-recipes.component';
import {CateringOrderRecipesComponent} from './components/modals/catering-order-recipes/catering-order-recipes.component';
import {CopyDiaryRecipesAdvancedComponent} from './components/modals/copy-diary-recipes-advanced/copy-diary-recipes-advanced.component';
import {VmvComponent} from './components/modals/shopping-list/vmv.component';

const MODALS = [
    AddRecipeModalComponent,
    AddRecipeFilterModalComponent,
    ViewRecipeComponent,
    ChangeDiaryRecipeProductComponent,
    ShoppingListComponent,
    ExternalMealsComponent,
    FriendsComponent,
    SendToFriendComponent,
    VmvComponent,
    WeightQtyComponent,
    DiaryMealComponent,
    CopyRecipeComponent,
    CopyDiaryRecipesComponent,
    CopyDiaryRecipesAdvancedComponent,
    CateringOrderRecipesComponent,
    DiaryTrainingComponent,
    DailyChangesActivitiesComponent,
    DeleteDiaryRecipesComponent,
];

const COMPONENTS = [
    ...MODALS,
    MealsComponent
];

@NgModule({
    imports: [
        ...MODULES,
        AutocompleteLibModule,
        NouisliderModule,
        NgCircleProgressModule,
        LazyLoadImageModule
    ],
    entryComponents: [
        ...MODALS
    ],
    exports: [
        MealsComponent
    ],
    declarations: [
        ...COMPONENTS
    ]
})
export class MealsModule {
}
